import React, { useEffect, useRef, useState } from "react";
import CommonDropdown from "../CommonDropdown";
import NivoBarchart from "../../../Nivo/Nivo_Barchart";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountOnLeadBarData,
  getCountOnLeadCardsData,
  report_countsonLead,
} from "./CountonLeadSlice";
import { Loader, PdfModal } from "../../../Util/common";
import StackedBarChart from "../../../ChartsJs/StatckedBar";
import {
  downloadPDF,
  printDocument,
} from "../../../ChartsJs/DownlaodExportImage";
import { baseURL } from "../../../Util/axios_helper";
import { KendoGrid } from "../../../Kendo/kendo_grid";

const CountsOnLead = () => {
  const dispatch = useDispatch();
  const { cardData, barData, barDataLoaded, cardDataLoaded } = useSelector(
    (state) => state.countonLead
  );
  const { type, year, filter, metrics, value } = useSelector(
    (state) => state.revenue
  );
  const [NewStatusCount, setNewStatusCount] = useState(0);
  const [RecommendationStatusCount, setRecommendationStatusCount] = useState(0);
  const [TourBookedStatusCount, setTourBookedStatusCount] = useState(0);
  const [TourDoneStatusCount, setTourDoneStatusCount] = useState(0);
  const [TCSentStatusCount, setTCSentStatusCount] = useState(0);
  const [NoShowStatusCount, setNoShowStatusCount] = useState(0);
  const [Guaranteed, setGuaranteed] = useState(0);
  const [Closed, setClosed] = useState(0);
  const [SpokenToClient, setSpokenToClient] = useState(0);
  const [DateNA, setDateNA] = useState(0);
  const [TotalCount, setTotalCount] = useState(0);
  const [label, setlabel] = useState([]);
  const [data, setData] = useState([]);
  const [legend, setLegend] = useState([]);
  const [refreshflag, setrefreshflag] = useState(0);
  const [flag, setflag] = useState(false);
  const [exportFName, setexportFName] = useState("");
  const [URL, setURL] = useState("");
  const [title, settitle] = useState("");
  const [minVal, setminVal] = useState(0);
  const [maxVal, setmaxVal] = useState(11);

  function getISOWeekNumber(date) {
    const tempDate = new Date(date);
    tempDate.setHours(0, 0, 0, 0);
    tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));
    const yearStart = new Date(tempDate.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(((tempDate - yearStart) / 86400000 + 1) / 7);
    return weekNumber;
  }

  function getMinAndMaxWeekNumbers() {
    const today = new Date();
    const maxWeekNumber = getISOWeekNumber(today);

    const minDate = new Date(today);
    minDate.setDate(today.getDate() - 12 * 7);
    const minWeekNumber = getISOWeekNumber(minDate);

    return { maxWeekNumber, minWeekNumber };
  }

  useEffect(() => {
    if (cardData && cardData != undefined && cardDataLoaded) {
      let setValues = cardData?.Records != undefined ? cardData?.Records[0] : 0;
      setNewStatusCount(setValues?.NewStatusCount);
      setRecommendationStatusCount(setValues?.RecommendationStatusCount);
      setTourBookedStatusCount(setValues?.TourBookedStatusCount);
      setTourDoneStatusCount(setValues?.TourDoneStatusCount);
      setTCSentStatusCount(
        (setValues?.TCSentStatusCount ?? 0) +
          (setValues?.CCSentStatusCount ?? 0)
      );
      setNoShowStatusCount(setValues?.NoShowStatusCount);
      setGuaranteed(setValues?.Guaranteed);
      setClosed(setValues?.Closed);
      setSpokenToClient(setValues?.SpokenToClient);
      setDateNA(setValues?.DateNA);
      setTotalCount(setValues?.TotalCount);
    }
  }, [cardDataLoaded]);

  useEffect(() => {
    if (barData && barData != undefined && barDataLoaded) {
      const xaxis = barData?.XAxis;
      const yaxis = barData?.YAxis;
      const matrix = barData?.matrix;
      setlabel(xaxis);
      setData(yaxis);
      setLegend(matrix);

      if (metrics.type == "Week" && yaxis && yaxis.length > 11) {
        const { maxWeekNumber, minWeekNumber } = getMinAndMaxWeekNumbers();
        setmaxVal(maxWeekNumber);
        setminVal(minWeekNumber);
      } else {
        setmaxVal(11);
        setminVal(0);
      }
    }
  }, [barDataLoaded]);

  const CountOnLeadStatusRef = useRef();
  const handlePrintDocument = () => {
    const orientation = "landscape";
    printDocument(CountOnLeadStatusRef, "CountOnLeadStatus", orientation);
  };

  return (
    <>
      <button
        className="pfdexportIcon"
        onClick={handlePrintDocument}
        title="Download Full Screen"
      >
        <i className="lar la-file-pdf"></i>
      </button>
      <div className="pdfContent" ref={CountOnLeadStatusRef}>
        <div className="page-header">
          <div className="row">
            <div className="col-md-3">
              <h3 className="page-title">Counts on Lead Status</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Counts on Lead </li>
              </ul>
            </div>
            <div className="col-md-9">
              <CommonDropdown CountsOnLead={true} />
            </div>
          </div>
        </div>

        <div className="Widgets">
          <div className="row ten-cols">
            <div className="col-md-1" title="View Total Lead Report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  // When the user clicks anywhere outside of the modal, close it
                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"TC Sent,CC Sent,Guaranteed,R Mail sent - Automated,R Mail sent - Manual,R email sent Tour Not Booked,Tour Booked,Tour - Done,Tour Booked but No Show,Closed,Date N/A,Spoke to Client - Tour N/B"}&value=${
                      metrics.metricesValue
                    }`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("Total Lead Report");
                  setexportFName("TotalLead_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-address-card"></i>{" "}
                    </span>
                    <div className="dash-widget-info">
                      <h3>{TotalCount > 0 ? TotalCount : "0"}</h3>
                      <span>Total Lead</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-1" title="View TC/CC Sent report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"TC Sent,CC Sent"}&value=${
                      metrics.metricesValue
                    }`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("TC/CC sent Report");
                  setexportFName("TC/CCsent_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-newspaper"></i>{" "}
                    </span>
                    <div className="dash-widget-info">
                      <h3>{TCSentStatusCount > 0 ? TCSentStatusCount : "0"}</h3>
                      <span>TC/CC Sent</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-1" title="View Guranteed report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Guaranteed"}&value=${metrics.metricesValue}`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle(" Guranteed Report");
                  setexportFName("Guranteed_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-file-contract"></i>
                    </span>
                    <div className="dash-widget-info">
                      <h3>{Guaranteed > 0 ? Guaranteed : "0"}</h3>
                      <span>Guranteed</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-1" title="View R-Mail Sent report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"R Mail sent - Automated,R email sent Tour Not Booked,R Mail sent - Manual"}&value=${
                      metrics.metricesValue
                    }`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle(" R-Mail Sent Report");
                  setexportFName("R-Mail_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-envelope"></i>{" "}
                    </span>
                    <div className="dash-widget-info">
                      <h3>
                        {RecommendationStatusCount > 0
                          ? RecommendationStatusCount
                          : "0"}
                      </h3>
                      <span>R-Mail Sent</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-md-1" title="View Tour Booked report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Tour Booked"}&value=${metrics.metricesValue}`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("Tour Booked Report");
                  setexportFName("TourBooked_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-calendar-alt"></i>{" "}
                    </span>
                    <div className="dash-widget-info">
                      <h3>
                        {TourBookedStatusCount > 0
                          ? TourBookedStatusCount
                          : "0"}
                      </h3>
                      <span>Tour Booked</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-md-1" title="view Tour Done report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Tour - Done"}&value=${metrics.metricesValue}`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("Tour Done Report");
                  setexportFName("TourDone_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-calendar-check"></i>{" "}
                    </span>
                    <div className="dash-widget-info">
                      <h3>
                        {TourDoneStatusCount > 0 ? TourDoneStatusCount : "0"}
                      </h3>
                      <span>Tour Done</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-md-1" title="view no show report">
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Tour Booked but No Show"}&value=${
                      metrics.metricesValue
                    }`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("No Shows Report");
                  setexportFName("NoShows_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-calendar-times"></i>{" "}
                    </span>
                    <div className="dash-widget-info">
                      <h3>{NoShowStatusCount > 0 ? NoShowStatusCount : "0"}</h3>
                      <span>No Shows</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-1" title="view Closed report">
              {" "}
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Closed"}&value=${metrics.metricesValue}`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("Closed Report");
                  setexportFName("Closed_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-times-circle"></i>
                    </span>
                    <div className="dash-widget-info">
                      <h3>{Closed > 0 ? Closed : "0"}</h3>
                      <span>Closed</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className="col-md-1" title="view Date N/A report">
              {" "}
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Date N/A"}&value=${metrics.metricesValue}`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("Date N/A Report");
                  setexportFName("DateN/A_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-calendar-times"></i>
                    </span>
                    <div className="dash-widget-info">
                      <h3>{DateNA > 0 ? DateNA : "0"}</h3>
                      <span>Date N/A</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div
              className="col-md-1"
              title="view Spoken to client - Tour N/B report"
            >
              <a
                href={`#`}
                onClick={(e) => {
                  var modal = document.getElementById("LeadModal");
                  modal.style.display = "block";

                  var span = document.getElementById("close");
                  span.onclick = function () {
                    modal.style.display = "none";
                  };

                  window.onclick = function (event) {
                    if (event.target == modal) {
                      modal.style.display = "none";
                    }
                  };
                  setflag(true);
                  setURL(
                    `${baseURL}Report/CountsOnLead_Report?type=${
                      metrics.type
                    }&years=${year}&filter=${
                      metrics.filter
                    }&metrics=${"Spoke to Client - Tour N/B"}&value=${
                      metrics.metricesValue
                    }`
                  );
                  setrefreshflag(refreshflag + 1);
                  settitle("Spoken to client - Tour N/B Report");
                  setexportFName("SpokentoclientTourN/B_Report");
                }}
              >
                <div className="card dash-widget">
                  <div className="card-body">
                    <span className="dash-widget-icon">
                      <i class="las la-phone-alt"></i>
                    </span>
                    <div className="dash-widget-info">
                      <h3>{SpokenToClient > 0 ? SpokenToClient : "0"}</h3>
                      <span>Spoken to client - Tour N/B</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="col-xs-12 mt-2 files">
                {/* <div
                className="ms-2 me-2 "
                title="Export to Pdf"
                style={{
                  position: "relative",
                  float: "right",
                  cursor: "pointer",
                }}
                onClick={() =>
                  downloadPDF("countsonLead", "Counts On Lead Status", 80, 3)
                }
              >
                <span className="files-icon">
                  <i class="las la-image"></i>
                </span>
              </div> */}
                <a
                  href={`#`}
                  onClick={() => {
                    var modal = document.getElementById("LeadCPDFmodal");
                    modal.style.display = "block";
                    var span = document.getElementById("LeadCPDFclose");
                    span.onclick = function () {
                      modal.style.display = "none";
                    };

                    // When the user clicks anywhere outside of the modal, close it
                    window.onclick = function (event) {
                      if (event.target == modal) {
                        modal.style.display = "none";
                      }
                    };
                  }}
                >
                  <div
                    title="View Report"
                    className="ms-2 me-2"
                    style={{
                      position: "relative",
                      float: "right",
                      cursor: "pointer",
                    }}
                  >
                    <span className="files-icon">
                      <i className="las la-image"></i>
                    </span>
                  </div>
                </a>
                <a
                  href={`#`}
                  onClick={(e) => {
                    var modal = document.getElementById("LeadModal");
                    modal.style.display = "block";

                    var span = document.getElementById("close");
                    span.onclick = function () {
                      modal.style.display = "none";
                    };

                    window.onclick = function (event) {
                      if (event.target == modal) {
                        modal.style.display = "none";
                      }
                    };
                    setflag(true);
                    const metricesValue =
                      metrics.metrices === "Ballroom"
                        ? "TC Sent,CC Sent,Guaranteed,R Mail sent - Automated,R Mail sent - Manual,R email sent Tour Not Booked,Tour Booked,Tour - Done,Tour Booked but No Show,Closed,Date N/A,Spoke to Client - Tour N/B"
                        : metrics.metrices;
                    setURL(
                      `${baseURL}Report/CountsOnLead_Report?type=${metrics.type}&years=${year}&filter=${metrics.filter}&metrics=${metricesValue}&value=${metrics.metricesValue}`
                    );
                    setrefreshflag(refreshflag + 1);
                    settitle("Counts on leads status");
                    setexportFName("CountsOnLeadStatus");
                  }}
                >
                  <div
                    title="View Counts On leads report"
                    className=""
                    style={{
                      position: "relative",
                      float: "right",
                      cursor: "pointer",
                    }}
                  >
                    <span className="files-icon">
                      <i class="las la-file-alt"></i>
                    </span>
                  </div>
                </a>
              </div>

              <div className="card-body">
                <div>
                  <StackedBarChart
                    data={data}
                    type={"bar"}
                    labels={label}
                    legend={legend}
                    titl={year}
                    XAxisLabel={metrics.type}
                    YAxisLabel={"Counts"}
                    id={"countsonLead"}
                    chartType={"CountOnLead"}
                    countOnLead={true}
                    barDataLoaded={barDataLoaded}
                    minVal={minVal}
                    maxVal={maxVal}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- RingCentral Report Popup --> */}
        <div id="LeadModal" class="cmodal">
          <div class="cmodal-content">
            <div className="modal-header">
              <h5 className="modal-title-popup">{title}</h5>
              <span class="close" id="close">
                &times;
              </span>
            </div>
            <div className="row">
              <div className="col-md-12">
                {flag && (
                  <KendoGrid
                    exportFileName={exportFName}
                    name={"Rc_Report"}
                    paggable={true}
                    url={URL}
                    schema={{}}
                    refreshWhen={refreshflag}
                    columns={[
                      {
                        field: "LeadName",
                        title: "Lead Name",
                        width: 90,
                      },
                      {
                        field: "LeadCreatedDate",
                        title: "Created Date",
                        width: 150,
                      },
                      {
                        field: "EventDate",
                        title: "Event Date",
                        width: 150,
                      },
                      {
                        field: "PrimaryEmail",
                        title: "Primary Email",
                        template: function (dataItem) {
                          return $("<div/>").html(dataItem.PrimaryEmail).text();
                        },
                        width: 150,
                      },
                      {
                        field: "PrimaryContact",
                        title: "Primary Contact",
                        template: function (dataItem) {
                          return $("<div/>")
                            .html(dataItem.PrimaryContact)
                            .text();
                        },
                        width: 150,
                      },
                      {
                        field: "NoofAttendance",
                        title: "Attendance",
                        width: 110,
                      },
                      {
                        field: "Description",
                        title: "Description",
                        width: 110,
                      },
                      {
                        field: "LeadType",
                        title: "Lead Type",
                        width: 100,
                      },
                      {
                        field: "LeadStatus",
                        title: "Lead Status",
                        width: 120,
                      },
                      {
                        field: "TourDone",
                        title: "Tour Done",
                        width: 120,
                        template: "#= TourDone !== null ? TourDone : 'No' #",
                      },
                      {
                        field: "TourDate",
                        title: "Tour Date",
                        width: 120,
                      },
                      {
                        field: "Converted",
                        title: "Converted",
                        width: 120,
                      },
                      {
                        field: "ConversionDate",
                        title: "Conversion Date",
                        template: function (dataItem) {
                          const dateStr = dataItem.ConversionDate;
                          const datePart = dateStr ? dateStr.split(" ")[0] : "";
                          return datePart;
                        },
                        width: 120,
                      },
                    ]}
                    height={400}
                    showOptions={false}
                    showEdit={false}
                    showDelete={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End RingCentral Report Popup/ --> */}
        {/* <!-- Leads PDF Modal --> */}
        <PdfModal
          chart={
            <StackedBarChart
              data={data}
              type={"bar"}
              labels={label}
              legend={legend}
              titl={year}
              XAxisLabel={metrics.type}
              YAxisLabel={"Counts"}
              id={"countsonLeadPDF"}
              chartType={"CountOnLead"}
              countOnLead={true}
              barDataLoaded={barDataLoaded}
              minVal={minVal}
              maxVal={maxVal}
              ChartHeight={600}
              ValueFontSize={12}
            />
          }
          modalId={"LeadCPDFmodal"}
          modalcloseId={"LeadCPDFclose"}
          modalTitle={"Counts On Leads"}
          PDFDownload={() =>
            downloadPDF("countsonLeadPDF", "Counts On Lead Status", 90, 3)
          }
        />
        {/* <!-- End leads PDF Modal/ --> */}
      </div>
    </>
  );
};

export default CountsOnLead;
